import React, { useState, useEffect, useRef, useContext } from "react";

import { useHistory, useParams } from "react-router-dom";
import { format, isSameDay } from "date-fns";
import clsx from "clsx";

import { alpha, makeStyles } from "@material-ui/core/styles";
import {
  green,
  grey,
  red,
  blue,
  yellow,
  purple,
} from "@material-ui/core/colors";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import getTicketDisplayName from "../../utils/getTicketDisplayName";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import MarkdownWrapper from "../MarkdownWrapper";
import { Tooltip } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import toastError from "../../errors/toastError";
import { v4 as uuidv4 } from "uuid";
import updateTicketStatus from "../../utils/updateTicketStatus";
import { getTicketLastMessageDate } from "../../utils/messageDate";

import AndroidIcon from "@material-ui/icons/Android";
import VisibilityIcon from "@material-ui/icons/Visibility";
import TicketMessagesDialog from "../TicketMessagesDialog";
import ContactTag from "../ContactTag";
import TransferTicketModalCustom from "../TransferTicketModalCustom";

const useStyles = makeStyles((theme) => {
  const paletteMode = theme.palette.mode || theme.palette.type || "light";
  const isDarkMode = paletteMode === "dark";

  const softOpacity = isDarkMode ? 0.08 : 0.16;
  const mediumOpacity = isDarkMode ? 0.12 : 0.22;

  return {
    ticket: {
      position: "relative",
    },
    ticketOpenUser: {
      backgroundColor: alpha(theme.palette.success.main, softOpacity),
    },
    ticketPendingUser: {
      backgroundColor: alpha(theme.palette.warning.main, mediumOpacity),
    },
    ticketOpenGroup: {
      backgroundColor: alpha(theme.palette.info.main, softOpacity),
    },
    ticketPendingGroup: {
      backgroundColor: alpha(theme.palette.info.main, mediumOpacity),
    },
    internalTicket: {
      backgroundColor: alpha(theme.palette.error.main, mediumOpacity),
    },

    pendingTicket: {
      cursor: "unset",
    },
    queueTag: {
      background: "#FCFCFC",
      color: "#000",
      marginRight: 1,
      padding: 1,
      fontWeight: "bold",
      paddingLeft: 5,
      paddingRight: 5,
      borderRadius: 3,
      fontSize: "0.8em",
      whiteSpace: "nowrap",
    },
    noTicketsDiv: {
      display: "flex",
      height: "100px",
      margin: 40,
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    newMessagesCount: {
      position: "absolute",
      alignSelf: "center",
      marginRight: 8,
      marginLeft: "auto",
      top: "10px",
      left: "20px",
      borderRadius: 0,
    },
    noTicketsText: {
      textAlign: "center",
      color: "rgb(104, 121, 146)",
      fontSize: "14px",
      lineHeight: "1.4",
    },
    connectionTag: {
      background: "green",
      color: "#FFF",
      marginRight: 1,
      padding: 1,
      fontWeight: "bold",
      paddingLeft: 5,
      paddingRight: 5,
      borderRadius: 3,
      fontSize: "0.8em",
      whiteSpace: "nowrap",
    },
    noTicketsTitle: {
      textAlign: "center",
      fontSize: "16px",
      fontWeight: "600",
      margin: "0px",
    },

    contactNameWrapper: {
      display: "flex",
      justifyContent: "space-between",
      marginLeft: "5px",
    },

    lastMessageTime: {
      justifySelf: "flex-end",
      textAlign: "right",
      position: "relative",
      top: -21,
    },

    closedBadge: {
      alignSelf: "center",
      justifySelf: "flex-end",
      marginRight: 32,
      marginLeft: "auto",
    },

    contactLastMessage: {
      paddingRight: "0%",
      marginLeft: "5px",
    },

    badgeStyle: {
      color: "white",
      backgroundColor: green[500],
    },

    acceptButton: {
      position: "absolute",
      left: "50%",
    },

    ticketQueueColor: {
      flex: "none",
      width: "8px",
      height: "100%",
      position: "absolute",
      top: "0%",
      left: "0%",
    },

    ticketInfo: {
      position: "relative",
      top: -13,
    },
    secondaryContentSecond: {
      display: "flex",
      // marginTop: 5,
      //marginLeft: "5px",
      alignItems: "flex-start",
      flexWrap: "wrap",
      flexDirection: "row",
      alignContent: "flex-start",
    },
    ticketInfo1: {
      position: "relative",
      top: 13,
      right: 0,
    },
    Radiusdot: {
      "& .MuiBadge-badge": {
        borderRadius: 2,
        position: "inherit",
        height: 16,
        margin: 2,
        padding: 3,
      },
      "& .MuiBadge-anchorOriginTopRightRectangle": {
        transform: "scale(1) translate(0%, -40%)",
      },
    },
  };
});
{
  /*PLW DESIGN INSERIDO O dentro do const handleChangeTab*/
}
const TicketListItemCustom = ({ ticket, status, isGroup }) => {
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [ticketUser, setTicketUser] = useState(null);
  const [ticketQueueName, setTicketQueueName] = useState(null);
  const [ticketQueueColor, setTicketQueueColor] = useState(null);
  const [tag, setTag] = useState([]);
  const [whatsAppName, setWhatsAppName] = useState(null);
  const [queueSelectOpen, setQueueSelectOpen] = useState(false);
  const [selectedQueueId, setSelectedQueueId] = useState("");
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const isInternalTicket = Boolean(ticket?.isInternal);

  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
  const { ticketId } = useParams();
  const isMounted = useRef(true);
  const { setCurrentTicket } = useContext(TicketsContext);
  const { user } = useContext(AuthContext);
  const { profile } = user;
  const availableQueues = user?.queues || [];
  const hasQueue = Boolean(ticket.queueId || ticket.queue?.id);

  useEffect(() => {
    if (ticket.userId && ticket.user) {
      if (isInternalTicket && ticket.internalUserId === user?.id) {
        setTicketUser(ticket.internalUser?.name?.toUpperCase());
      } else {
        setTicketUser(ticket.user?.name?.toUpperCase());
      }
    }
    setTicketQueueName(ticket.queue?.name?.toUpperCase());
    setTicketQueueColor(ticket.queue?.color);

    if (ticket.whatsappId && ticket.whatsapp) {
      setWhatsAppName(ticket.whatsapp.name?.toUpperCase());
    }

    setTag(ticket?.tags);

    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  {
    /*CÓDIGO NOVO SAUDAÇÃO*/
  }
  const handleCloseTicket = async (skipFarewell = false) => {
    setTag(ticket?.tags);
    await updateTicketStatus({
      ticket,
      status: "closed",
      userId: user?.id,
      skipFarewell,
      history,
      setCurrentTicket,
      setLoading,
      onError: toastError,
    });
  };

  const handleReopenTicket = async (id) => {
    setLoading(true);
    try {
      await api.put(`/tickets/${id}`, {
        status: "open",
        userId: user?.id,
        queueId: ticket?.queue?.id,
      });
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
    if (isMounted.current) {
      setLoading(false);
    }
    history.push(`/tickets/${ticket.uuid}`);
  };

  const handleAcepptTicket = async (id, queueId) => {
    setLoading(true);
    try {
      const payload = {
        status: "open",
        userId: user?.id,
      };

      if (queueId) {
        payload.queueId = queueId;
      }
      await api.put(`/tickets/${id}`, {
        ...payload,
      });

      let settingIndex;

      try {
        const { data } = await api.get("/settings/");

        settingIndex = data.filter((s) => s.key === "sendGreetingAccepted");
      } catch (err) {
        toastError(err);
      }

      if (settingIndex[0].value === "enabled" && !ticket.isGroup) {
        handleSendMessage(ticket.id);
      }
    } catch (err) {
      setLoading(false);

      toastError(err);
    }
    if (isMounted.current) {
      setLoading(false);
    }

    // handleChangeTab(null, "tickets");
    // handleChangeTab(null, "open");
    history.push(`/tickets/${ticket.uuid}`);
  };

  const handleSendMessage = async (id) => {
    const msg = `{{ms}} *{{name}}*, meu nome é *${user?.name}* e agora vou prosseguir com seu atendimento!`;
    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: `*Mensagem Automática:*\n${msg.trim()}`,
    };
    try {
      await api.post(`/messages/${id}`, message);
    } catch (err) {
      toastError(err);
    }
  };

  /*CÓDIGO NOVO SAUDAÇÃO*/

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const handleAcceptClick = () => {
    if (!hasQueue) {
      const defaultQueueId =
        availableQueues.length === 1 ? availableQueues[0].id : "";
      setSelectedQueueId(defaultQueueId);
      setQueueSelectOpen(true);
      return;
    }

    handleAcepptTicket(ticket.id);
  };

  const handleConfirmQueue = () => {
    if (!selectedQueueId) return;
    setQueueSelectOpen(false);
    handleAcepptTicket(ticket.id, selectedQueueId);
  };

  const handleOpenTransferTicketModal = () => {
    setTransferTicketModalOpen(true);
  };

  const handleCloseTransferTicketModal = () => {
    setTransferTicketModalOpen(false);
  };

  const parsedLastMessageTimestamp = getTicketLastMessageDate(ticket);
  const hasValidLastMessageTimestamp = Boolean(parsedLastMessageTimestamp);

  const renderTicketInfo = () => {
    if (ticketUser) {
      return (
        <>
          {ticket.chatbot && (
            <Tooltip title={i18n.t("ticketsListItem.tooltip.chatbot")}>
              <AndroidIcon
                fontSize="small"
                style={{ color: grey[700], marginRight: 5 }}
              />
            </Tooltip>
          )}

          {/* </span> */}
        </>
      );
    } else {
      return (
        <>
          {ticket.chatbot && (
            <Tooltip title={i18n.t("ticketsListItem.tooltip.chatbot")}>
              <AndroidIcon
                fontSize="small"
                style={{ color: grey[700], marginRight: 5 }}
              />
            </Tooltip>
          )}
        </>
      );
    }
  };

  return (
    <React.Fragment key={ticket.id}>
      <TicketMessagesDialog
        open={openTicketMessageDialog}
        handleClose={() => setOpenTicketMessageDialog(false)}
        ticketId={ticket.id}
      />
      <TransferTicketModalCustom
        modalOpen={transferTicketModalOpen}
        onClose={handleCloseTransferTicketModal}
        ticketid={ticket.id}
      />
      <ListItem
        dense
        button
        onClick={(e) => {
          if (ticket.status === "pending") return;
          handleSelectTicket(ticket);
        }}
        selected={ticketId && +ticketId === ticket.id}
        className={clsx(classes.ticket, {
          [classes.pendingTicket]: ticket.status === "pending",
          [classes.ticketOpenUser]: status === "open" && isGroup === false,
          [classes.ticketPendingUser]:
            status === "pending" && isGroup === false,
          [classes.ticketOpenGroup]: status === "open" && isGroup === true,
          [classes.ticketPendingGroup]:
            status === "pending" && isGroup === true,
          [classes.internalTicket]: isInternalTicket,
        })}
        alignItems="flex-start"
      >
        <Tooltip
          arrow
          placement="right"
          title={
            ticket.queue?.name?.toUpperCase() ||
            i18n.t("ticketsListItem.noQueue")
          }
        >
          <span
            style={{ backgroundColor: ticket.queue?.color || "#7C7C7C" }}
            className={classes.ticketQueueColor}
          ></span>
        </Tooltip>

        <ListItemAvatar>
          <Avatar
            style={{
              marginTop: "0px",
              marginLeft: "0px",
              width: "55px",
              height: "55px",
              borderRadius: "10%",
            }}
            src={
              isInternalTicket
                ? "/nopicture.png"
                : ticket?.contact?.profilePicUrl
            }
            imgProps={{
              onError: (e) => {
                e.target.onerror = null;
                e.target.src = "/nopicture.png";
              },
            }}
          />
        </ListItemAvatar>

        <Box display="flex" flexDirection="column" flex={1}>
          <ListItemText
            disableTypography
            primary={
              <Box className={classes.contactNameWrapper}>
                <Typography
                  noWrap
                  component="span"
                  variant="body2"
                  color="textPrimary"
                >
                  {getTicketDisplayName(ticket, user?.id)}
                  {profile === "admin" && (
                    <Tooltip title={i18n.t("ticketsListItem.tooltip.peek")}>
                      <VisibilityIcon
                        onClick={() => setOpenTicketMessageDialog(true)}
                        fontSize="small"
                        style={{
                          color: blue[700],
                          cursor: "pointer",
                          marginLeft: 10,
                          verticalAlign: "middle",
                        }}
                      />
                    </Tooltip>
                  )}
                </Typography>
                <Box display="flex">
                  {/* Data */}
                  {hasValidLastMessageTimestamp && (
                    <Typography variant="body2" color="textSecondary">
                      {isSameDay(parsedLastMessageTimestamp, new Date())
                        ? format(parsedLastMessageTimestamp, "HH:mm")
                        : format(parsedLastMessageTimestamp, "dd/MM/yyyy")}
                    </Typography>
                  )}
                </Box>
              </Box>
            }
            secondary={
              <Box className={classes.contactNameWrapper}>
                <Typography
                  className={classes.contactLastMessage}
                  noWrap
                  component="span"
                  variant="body2"
                  color="textSecondary"
                >
                  {ticket.lastMessage.includes("data:image/png;base64") ? (
                    <MarkdownWrapper>Localização</MarkdownWrapper>
                  ) : (
                    <MarkdownWrapper
                      style={{
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        maxWidth: "100%",
                      }}
                    >
                      {ticket.lastMessage.length > 50
                        ? `${ticket.lastMessage.substring(0, 50)}...`
                        : ticket.lastMessage}
                    </MarkdownWrapper>
                  )}

                  <Box className={classes.secondaryContentSecond}>
                    {ticket?.whatsapp?.name && (
                      <Badge className={classes.connectionTag}>
                        {ticket?.whatsapp?.name?.toUpperCase()}
                      </Badge>
                    )}
                    {ticketUser && (
                      <Badge
                        style={{ backgroundColor: "#000000" }}
                        className={classes.connectionTag}
                      >
                        {ticketUser}
                      </Badge>
                    )}
                    <Badge
                      style={{
                        backgroundColor: ticket.queue?.color || "#7c7c7c",
                      }}
                      className={classes.connectionTag}
                    >
                      {ticket.queue?.name?.toUpperCase() ||
                        i18n.t("ticketsListItem.noQueue")}
                    </Badge>
                  </Box>

                  <Box
                    style={{ paddingTop: "0px" }}
                    className={classes.secondaryContentSecond}
                  >
                    {tag?.map((tag) => (
                      <ContactTag
                        tag={tag}
                        key={`ticket-contact-tag-${ticket.id}-${tag.id}`}
                      />
                    ))}
                  </Box>
                </Typography>

                <Badge
                  className={classes.newMessagesCount}
                  badgeContent={
                    ticket.unreadMessagesForUser ?? ticket.unreadMessages
                  }
                  classes={{
                    badge: classes.badgeStyle,
                  }}
                />
              </Box>
            }
          />

          {/* ✅ Bloco de data e botões abaixo */}
          <Box
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            mt={1}
            ml={1}
            pr={1}
          >
            {/* Botões */}
            <Box display="flex">
              {/* ml={3} → espaço entre data e primeiro botão */}

              {ticket.status === "pending" && (
                <ButtonWithSpinner
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    fontSize: "0.6rem",
                    borderRadius: "10px",
                  }}
                  variant="contained"
                  size="small"
                  loading={loading}
                  onClick={handleAcceptClick}
                >
                  {i18n.t("ticketsList.buttons.accept")}
                </ButtonWithSpinner>
              )}

              {ticket.status === "pending" && hasQueue && (
                <ButtonWithSpinner
                  style={{
                    backgroundColor: "#3f51b5",
                    color: "white",
                    fontSize: "0.6rem",
                    borderRadius: "10px",
                  }}
                  variant="contained"
                  size="small"
                  loading={loading}
                  onClick={handleOpenTransferTicketModal}
                >
                  {i18n.t("ticketOptionsMenu.transfer")}
                </ButtonWithSpinner>
              )}

              {ticket.status === "pending" && (
                <ButtonWithSpinner
                  style={{
                    backgroundColor: "#f57c00",
                    color: "white",
                    fontSize: "0.6rem",
                    borderRadius: "10px",
                  }}
                  variant="contained"
                  size="small"
                  loading={loading}
                  onClick={() => handleCloseTicket(true)}
                >
                  {i18n.t("messagesList.header.buttons.resolveWithoutMessage")}
                </ButtonWithSpinner>
              )}

              {ticket.status !== "closed" && (
                <ButtonWithSpinner
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    fontSize: "0.6rem",
                    borderRadius: "10px",
                  }}
                  variant="contained"
                  size="small"
                  loading={loading}
                  onClick={() => handleCloseTicket()}
                >
                  {i18n.t("ticketsList.buttons.closed")}
                </ButtonWithSpinner>
              )}

              {ticket.status === "closed" && (
                <ButtonWithSpinner
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    fontSize: "0.6rem",
                    borderRadius: "10px",
                  }}
                  variant="contained"
                  size="small"
                  loading={loading}
                  onClick={(e) => handleReopenTicket(ticket.id)}
                >
                  {i18n.t("ticketsList.buttons.reopen")}
                </ButtonWithSpinner>
              )}
            </Box>
          </Box>
        </Box>
      </ListItem>

      <Divider variant="inset" component="li" />
      <Dialog open={queueSelectOpen} onClose={() => setQueueSelectOpen(false)}>
        <DialogTitle>{i18n.t("ticketsList.queueSelect.title")}</DialogTitle>
        <DialogContent>
          <FormControl fullWidth variant="outlined" margin="dense">
            <InputLabel>{i18n.t("ticketsList.queueSelect.label")}</InputLabel>
            <Select
              label={i18n.t("ticketsList.queueSelect.label")}
              value={selectedQueueId}
              onChange={(e) => setSelectedQueueId(e.target.value)}
            >
              {availableQueues.map((queue) => (
                <MenuItem key={queue.id} value={queue.id}>
                  {queue.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setQueueSelectOpen(false)}>
            {i18n.t("transferTicketModal.buttons.cancel")}
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleConfirmQueue}
            disabled={!selectedQueueId}
          >
            {i18n.t("ticketsList.buttons.accept")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default TicketListItemCustom;
